module.exports = __webpack_public_path__ + "img/logowithletter.f97f075a.png";